import { render, staticRenderFns } from "./free-credit-modal.vue?vue&type=template&id=4a60f243&"
import script from "./free-credit-modal.vue?vue&type=script&lang=js&"
export * from "./free-credit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports